<section class="container py-4">
  <h2 mat-dialog-title>Add {{ isLink ? "Links" : "Documents" }}</h2>

  <mat-dialog-content>
    <form [formGroup]="uploadForm">
      <div
        *ngIf="!isLink"
        class="upload-dropzone"
        [class.dragging]="isDragging"
        (drop)="onDrop($event)"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (click)="fileInput.click()"
      >
        <input
          #fileInput
          hidden
          type="file"
          [accept]="allowedFileTypes"
          multiple
          (change)="onFileSelected($event)"
        />
        <p class="upload-text" *ngIf="selectedFiles.length === 0">
          Drag & drop files here or click to upload
        </p>
        <p class="upload-text" *ngIf="selectedFiles.length > 0">
          {{ selectedFiles.length }} file(s) selected.
          <span class="link-text">Click to add more</span>
        </p>
      </div>

      <div *ngIf="!isLink && selectedFiles.length > 0" class="mt-3">
        <div
          *ngFor="let item of selectedFiles; let i = index"
          class="file-edit-card mb-3 p-2 border rounded"
        >
          <div class="d-flex align-items-center justify-content-between mb-2">
            <div class="d-flex align-items-center">
              <mat-icon class="me-2">insert_drive_file</mat-icon>
              <small class="text-truncate" style="max-width: 200px">{{
                item.file.name
              }}</small>
            </div>
            <button
              mat-icon-button
              color="warn"
              (click)="removeSelectedFile(i, $event)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Document Title</mat-label>
            <input
              matInput
              [(ngModel)]="item.title"
              [ngModelOptions]="{ standalone: true }"
              placeholder="Enter title"
            />
          </mat-form-field>
        </div>
      </div>

      <div *ngIf="isLink" formArrayName="linkList">
        <div
          *ngFor="let linkGroup of linkList.controls; let i = index"
          [formGroupName]="i"
          class="border p-3 mb-3 rounded"
        >
          <div class="d-flex justify-content-between align-items-center">
            <h6>Link #{{ i + 1 }}</h6>
            <button
              mat-icon-button
              color="warn"
              (click)="removeLinkInput(i)"
              *ngIf="linkList.length > 1"
            >
              <mat-icon>remove_circle</mat-icon>
            </button>
          </div>
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>URL</mat-label>
            <input matInput formControlName="link" placeholder="https://..." />
          </mat-form-field>
        </div>
        <button mat-button type="button" (click)="addLinkInput()">
          <mat-icon>add</mat-icon> Add Link
        </button>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      (click)="onSubmit()"
      [disabled]="
        isUploading || (isLink ? linkList.invalid : selectedFiles.length === 0)
      "
    >
      <mat-spinner *ngIf="isUploading" diameter="20"></mat-spinner>
      <span *ngIf="!isUploading"> Upload </span>
    </button>
  </mat-dialog-actions>
</section>
